import {
  FAMILIARES_SUCCESS,
  FAMILIARES_LOADING,
  FAMILIARES_ERROR,
  RESET_PORTAL_CONTEXT,
} from "../ActionTypes";
import familiaresInitialState from "../initialStates/familiaresInitialState";

const familiares = (state, { payload, type }) => {
  switch (type) {
    case FAMILIARES_LOADING:
      return {
        ...state,
        familiares: {
          ...state.familiares,
          error: false,
          loading: true,
        },
      };
    case FAMILIARES_SUCCESS:
      return {
        ...state,
        familiares: {
          ...state.familiares,
          loading: false,
          error: false,
          data: payload,
        },
      };
    case FAMILIARES_ERROR:
      return {
        ...state,
        familiares: {
          ...state.familiares,
          error: payload,
          loading: false,
        },
      };
    case RESET_PORTAL_CONTEXT:
      return familiaresInitialState;
    default:
      return state;
  }
};

export default familiares;
